import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { TID } from "@/lib/testIds";
import { formatDate, statusClass } from "@/lib/format";
import { Building2, FolderKanban } from "lucide-react";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get("/clients")
      .then((r) => setClients(r.data.items))
      .catch((e) => setErr(e?.response?.data?.detail || e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid={TID.clientsPage} className="space-y-4">
      <p className="text-sm text-neutral-400 max-w-2xl">
        Clienti e relativi progetti in corso. Uno stato reale, in un colpo d&apos;occhio.
      </p>

      {err && (
        <div className="border border-red-900/60 bg-red-950/20 px-4 py-3 font-mono text-xs text-red-300">
          {err}
        </div>
      )}

      {loading && <div className="font-mono text-xs text-neutral-500"><span className="cursor-blink">LOADING</span></div>}

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {clients.map((c) => (
          <Link
            key={c.id}
            to={`/app/clients/${c.id}`}
            data-testid={TID.clientCard}
            className="group border border-[#1F1F1F] hover:border-[#333] bg-[#0C0C0C] hover:bg-[#141414] block transition-colors"
          >
            <header className="border-b border-[#1F1F1F] px-4 py-3 flex items-start justify-between bg-[#141414] group-hover:bg-[#191919]">
              <div>
                <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-500 flex items-center gap-2">
                  <Building2 className="w-3 h-3" strokeWidth={1.5} />
                  {c.id}
                </div>
                <h3 className="font-heading uppercase text-xl tracking-tight mt-1">{c.name}</h3>
                <div className="font-mono text-[10px] text-neutral-500 mt-1">{c.sector}</div>
              </div>
              <span className={`font-mono text-[9px] uppercase tracking-widest border px-1.5 py-0.5 ${statusClass(c.status)}`}>
                {c.status}
              </span>
            </header>
            <div className="p-4 space-y-3">
              <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-500 flex items-center gap-2">
                <FolderKanban className="w-3 h-3" strokeWidth={1.5} />
                Progetti · {c.projects.length}
              </div>
              <ul className="space-y-2">
                {c.projects.map((p) => (
                  <li key={p.id} className="text-sm">
                    <div className="text-neutral-200">{p.name}</div>
                    <div className="font-mono text-[10px] text-neutral-500 mt-0.5">
                      {p.milestone_current} · {p.milestones_done}/{p.milestones_total} milestone
                    </div>
                  </li>
                ))}
              </ul>
              <div className="pt-2 font-mono text-[10px] text-neutral-500 border-t border-[#1F1F1F]">
                cliente da · {formatDate(c.since)}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
